export const ACTION_STATUS = {
  ERROR: 'ERROR',
  WARNING: 'WARNING',
  OK: 'OK',
  ERROR_AND_WARNING: 'ERROR_AND_WARNING',
  BLOCKING: 'BLOCKING'
}
